import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserDefinedDataType } from '@core/enums/user-defined-data-type.enum';
import { UserDefinedFieldGroup } from '@core/models/shared/user-defined-field.model';

@Component({
    selector: 'app-user-defined-field',
    templateUrl: './user-defined-field.component.html',
    styleUrl: './user-defined-field.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserDefinedFieldComponent {
  static readonly componentName = 'UserDefinedFieldComponent';
  
  @Input() form: FormGroup;
  @Input() userDefinedFieldGroup: FormGroup<UserDefinedFieldGroup>;
  public dataType = UserDefinedDataType;
}
